export class PriceBookAccountingCodeModel {
    ID: string
    Name: string
    Description: string
    public constructor(){
        this.ID=""
    }
}


export class PriceModel {
    ID: string
    Amount: string
    Bucket: PriceBucketModel
    IsDirty: boolean
    public constructor(){
        this.ID="";
        this.Amount = "";
        this.IsDirty = false;
        this.Bucket = new PriceBucketModel()
    }
}

export class PriceBucketModel {
    ID: string
    Name: string
    IsNameEditable: boolean
    IsMandatory:boolean
    public constructor(){
        this.ID=""
    }
}